import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ButtonsBar from 'components/ButtonsBar';
import { VeevaSyncStatus } from 'modules/maya/basics/enums/maya.enums';
import {
  FormLayoutContainer,
  FormLayoutMidPanel,
  FormLayoutMidPanelContent,
  FormLayoutMidPanelHeader,
  FormLayoutRightPanel,
} from 'modules/maya/components/FormLayout';
import Heading from 'modules/maya/components/Heading';
import MayaLayout from 'modules/maya/components/MayaLayout/MayaLayout';
import VeevaStatusBar from 'modules/maya/components/VeevaStatusBar/VeevaStatusBar';
import useCepView from 'modules/maya/routes/CepView/CepView.hook';
import { CepViewStepsIndex } from 'modules/maya/routes/CepView/CepView.types';
import CepConfigView from 'modules/maya/routes/CepView/Steps/CepConfigView/CepConfigView';
import TacticsView from 'modules/maya/routes/CepView/Steps/TacticsView/TacticsView';
import TargetListView from 'modules/maya/routes/CepView/Steps/TargetListView/TargetListView';
import Box from 'yoda-ui/Box';
import Stepper from 'yoda-ui/Stepper/Stepper';

const CepView: FC = () => {
  const { t } = useTranslation();
  const {
    buttonsConfig,
    cep,
    handleChangeStep,
    stepIndexer,
    stepsList,
  } = useCepView();

  return (
    <MayaLayout>
      <FormLayoutContainer>
        <FormLayoutMidPanel >
          <FormLayoutMidPanelHeader>
            <Stepper
              handleChangeStep={ handleChangeStep }
              stepsList={ stepsList }
              stepIndex={ stepIndexer.stepIndex }
            />
          </FormLayoutMidPanelHeader>
          <FormLayoutMidPanelContent>
            <Heading>
              { t('maya_cep_view') }
              <VeevaStatusBar
                lastVeevaSync={ cep?.lastVeevaSync }
                lastVeevaSyncErrors={ cep?.lastVeevaSyncError ? [cep?.lastVeevaSyncError] : undefined }
                veevaSyncStatus={ cep?.veevaSyncStatus as VeevaSyncStatus }
              />
            </Heading>

            {
              stepIndexer.stepIndex === CepViewStepsIndex.configurationStep
                ? (
                  <Box width="100%">
                    <CepConfigView cep={ cep } />
                  </Box>
                )
                : null
            }
            {
              stepIndexer.stepIndex === CepViewStepsIndex.targetListStep
                ? (
                  <Box width="100%">
                    <TargetListView/>
                  </Box>
                )
                : null
            }
            {
              stepIndexer.stepIndex === CepViewStepsIndex.tacticsStep
                ? (
                  <Box width="100%">
                    <TacticsView/>
                  </Box>
                )
                : null
            }
          </FormLayoutMidPanelContent>
        </FormLayoutMidPanel>

        <FormLayoutRightPanel >
        </FormLayoutRightPanel>

      </FormLayoutContainer>
      { buttonsConfig && <ButtonsBar { ...buttonsConfig } /> }
    </MayaLayout>
  );
};

export default CepView;

